import React from "react";

import {
  FaUser,
  FaCamera,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaVenusMars,
  FaIdCard,
  FaHeart,
  FaEdit,
  FaDownload,
  FaInfoCircle,
} from "react-icons/fa";

import "./MemberPages.css";

function MyProfile() {
  const member = {
    name: "Ramesh Babu",
    memberId: "APNBM240520001",
    mobile: "+91 91234 56789",
    email: "rameshbabu@email.com",
    dob: "12/05/1990",
    gender: "Male",
    fatherName: "Suresh Babu",
    maritalStatus: "Married",

    membershipType: "Annual Membership",
    membershipStatus: "Active",
    validTill: "19 May 2025",

    currentAddress:
      "D.No: 12-3-45, Guntur, Andhra Pradesh - 522001",

    permanentAddress:
      "D.No: 12-3-45, Guntur, Andhra Pradesh - 522001",
  };

  const handleDownloadProfile = () => {
    alert("Profile download will be connected to the backend.");
  };

  const handleUpdatePhoto = () => {
    alert("Photo update will be connected to the backend.");
  };

  const handleEditProfile = () => {
    alert("Edit profile will be connected to the profile form.");
  };

  const handleUpdateAddress = (type) => {
    alert(`Update ${type} address will be connected to the address form.`);
  };

  return (
    <div className="profile-page">

      {/* ==================================================
          PAGE HEADER
      ================================================== */}

      <div className="profile-page-header">

        <div>
          <h1>My Profile</h1>

          <div className="breadcrumb">
            <span>Home</span>

            <span className="breadcrumb-arrow">
              ›
            </span>

            <span>My Profile</span>
          </div>
        </div>

        <button
          type="button"
          className="download-profile-btn"
          onClick={handleDownloadProfile}
        >
          <FaDownload />
          <span>Download Profile</span>
        </button>

      </div>


      {/* ==================================================
          MAIN PROFILE CARD
      ================================================== */}

      <div className="profile-main-card">

        {/* ==================================================
            LEFT PROFILE
        ================================================== */}

        <div className="profile-left">

          <div className="profile-photo-wrapper">

            <div className="profile-photo">
              <FaUser />
            </div>

            <button
              type="button"
              className="camera-button"
              title="Update Photo"
              onClick={handleUpdatePhoto}
            >
              <FaCamera />
            </button>

          </div>


          <h2>
            {member.name}
          </h2>


          <p className="profile-member-id">
            {member.memberId}
          </p>


          <span className="active-badge">
            Active Member
          </span>


          <button
            type="button"
            className="update-photo-btn"
            onClick={handleUpdatePhoto}
          >
            <FaCamera />
            <span>Update Photo</span>
          </button>

        </div>


        {/* ==================================================
            PERSONAL INFORMATION
        ================================================== */}

        <div className="profile-basic-info">

          <div className="section-title">

            <div className="section-icon blue">
              <FaUser />
            </div>

            <h3>
              Personal Information
            </h3>

          </div>


          <div className="profile-info-grid">

            <InfoRow
              icon={<FaUser />}
              label="Full Name"
              value={member.name}
            />

            <InfoRow
              icon={<FaIdCard />}
              label="Member ID"
              value={member.memberId}
            />

            <InfoRow
              icon={<FaUser />}
              label="Father / Husband Name"
              value={member.fatherName}
            />

            <InfoRow
              icon={<FaCalendarAlt />}
              label="Date of Birth"
              value={member.dob}
            />

            <InfoRow
              icon={<FaVenusMars />}
              label="Gender"
              value={member.gender}
            />

            <InfoRow
              icon={<FaPhone />}
              label="Mobile Number"
              value={member.mobile}
            />

            <InfoRow
              icon={<FaEnvelope />}
              label="Email"
              value={member.email}
            />

            <InfoRow
              icon={<FaHeart />}
              label="Marital Status"
              value={member.maritalStatus}
            />

          </div>


          <button
            type="button"
            className="edit-profile-btn"
            onClick={handleEditProfile}
          >
            <FaEdit />
            <span>Edit Profile</span>
          </button>

        </div>

      </div>


      {/* ==================================================
          CONTACT + MEMBERSHIP
      ================================================== */}

      <div className="profile-columns">

        {/* ==================================================
            CONTACT INFORMATION
        ================================================== */}

        <section className="profile-section-card">

          <div className="section-title">

            <div className="section-icon green">
              <FaPhone />
            </div>

            <h3>
              Contact Information
            </h3>

          </div>


          <div className="contact-item">

            <div className="contact-icon">
              <FaPhone />
            </div>

            <div>

              <span>
                Mobile Number
              </span>

              <strong>
                {member.mobile}
              </strong>

            </div>

          </div>


          <div className="contact-item">

            <div className="contact-icon">
              <FaEnvelope />
            </div>

            <div>

              <span>
                Email Address
              </span>

              <strong>
                {member.email}
              </strong>

            </div>

          </div>

        </section>


        {/* ==================================================
            MEMBERSHIP INFORMATION
        ================================================== */}

        <section className="profile-section-card">

          <div className="section-title">

            <div className="section-icon purple">
              <FaIdCard />
            </div>

            <h3>
              Membership Information
            </h3>

          </div>


          <div className="membership-info">

            <InfoRow
              label="Membership ID"
              value={member.memberId}
            />

            <InfoRow
              label="Membership Type"
              value={member.membershipType}
            />

            <InfoRow
              label="Membership Status"
              value={
                <span className="status-active">
                  {member.membershipStatus}
                </span>
              }
            />

            <InfoRow
              label="Valid Till"
              value={member.validTill}
            />

          </div>

        </section>

      </div>


      {/* ==================================================
          ADDRESS DETAILS
      ================================================== */}

      <section className="profile-section-card address-card">

        <div className="section-title">

          <div className="section-icon orange">
            <FaMapMarkerAlt />
          </div>

          <h3>
            Address Details
          </h3>

        </div>


        <div className="address-grid">

          <AddressBox
            title="Current Address"
            address={member.currentAddress}
            onUpdate={() =>
              handleUpdateAddress("Current")
            }
          />


          <AddressBox
            title="Permanent Address"
            address={member.permanentAddress}
            onUpdate={() =>
              handleUpdateAddress("Permanent")
            }
          />

        </div>

      </section>


      {/* ==================================================
          INFORMATION MESSAGE
      ================================================== */}

      <div className="profile-information">

        <FaInfoCircle />

        <span>
          If you find any incorrect information, please
          update it. For further assistance, contact our
          support team.
        </span>

      </div>

    </div>
  );
}


/* ==========================================================
   INFORMATION ROW
========================================================== */

function InfoRow({
  icon,
  label,
  value,
}) {
  return (
    <div className="info-row">

      <div className="info-label">

        {icon && (
          <span className="row-icon">
            {icon}
          </span>
        )}

        <span>
          {label}
        </span>

      </div>


      <span className="colon">
        :
      </span>


      <strong className="info-value">
        {value}
      </strong>

    </div>
  );
}


/* ==========================================================
   ADDRESS BOX
========================================================== */

function AddressBox({
  title,
  address,
  onUpdate,
}) {
  return (
    <div className="address-box">

      <h4>
        {title}
      </h4>


      <p>
        {address}
      </p>


      <button
        type="button"
        className="small-edit-btn"
        onClick={onUpdate}
      >
        <FaEdit />
        <span>Update Address</span>
      </button>

    </div>
  );
}


export default MyProfile;